module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead15-5aba0c363145b37aec67b82365f0653f.jpg";